export const CASE_SUMMARY_TAB = {
    application: { path: 'application', label: 'Application' },
    notes: { path: 'notes', label: 'Notes' },
    documents: { path: 'documents', label: 'Documents' },
    underwriting: { path: 'underwriting', label: 'Underwriting' },
    uwDecisions: { path: 'uw-decisions', label: 'UW Decisions' },
    callList: { path: 'call-list', label: 'Call List' },
    billing: { path: 'billing', label: 'Billing' },
    metrics: { path: 'metrics', label: 'Metrics' },
    caseHistory: { path: 'case-history', label: 'Case History' },
} as const;

export const CASE_SUMMARY_TABS = Object.values(CASE_SUMMARY_TAB);

export type CaseSummaryTabPath = typeof CASE_SUMMARY_TABS[number]['path'];
